var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoBlueCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25264 8.4958C3.58948 8.15895 4.13562 8.15895 4.47247 8.4958L7.89734 11.9207C8.23419 12.2575 8.23419 12.8037 7.89734 13.1405C7.5605 13.4774 7.01436 13.4774 6.67751 13.1405L3.25264 9.71563C2.91579 9.37878 2.91579 8.83265 3.25264 8.4958Z",
    fill: "#0047FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.748 5.07002C15.0848 5.40686 15.0848 5.953 14.748 6.28985L7.89825 13.1396C7.5614 13.4764 7.01526 13.4764 6.67842 13.1396C6.34157 12.8028 6.34157 12.2566 6.67842 11.9198L13.5282 5.07002C13.865 4.73317 14.4112 4.73317 14.748 5.07002Z",
    fill: "#0047FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBlueCheck);
export default __webpack_public_path__ + "static/media/ico_blue_check.1e13e763bca14c9be21491e24d02c846.svg";
export { ForwardRef as ReactComponent };